import React from 'react';
import {
    Row,
    Col,
    Button,
    message,
    Input,
    Typography,
    Divider,
    Form
} from 'antd';
import {
    FaSave
} from "react-icons/fa";
import { useMutation } from '@tanstack/react-query';
import axios from '../../../config/axios';

function ChangePasswordForm() {
    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();
    const { mutate, isLoading } = useMutation({
        mutationFn: (data) => {
            axios
                .post(`/auth/changepassword`, data)
                .then(() => {
                    messageApi.open({
                        type: 'success',
                        content: 'Password has been change.',
                        duration: 1,
                        onClose: () => {
                            localStorage.clear();
                            window.location.replace('/');
                        }
                    });
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'Something went wrong please check you data or contact Admin.',
                    });
                })
        },
    });

    const onFinish = (values) => {
        if (values.password_new !== values.confirm_password) {
            messageApi.open({
                type: 'error',
                content: 'Confirm password not match!',
            });
        } else {
            mutate(values);
        }
    }

    return (
        <div>
            {contextHolder}
            <Divider />
            <Typography.Title level={5}>
                Change password
            </Typography.Title>
            <Row>
                <Col xs={24} md={16}>
                    <Form
                        form={form}
                        layout="vertical"
                        name='formChangePassword'
                        onFinish={onFinish}
                    >
                        <Form.Item
                            name="password_old"
                            label="Old Password"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input data!',
                                },
                            ]}
                        >
                            <Input.Password />
                        </Form.Item>
                        <Form.Item
                            name="password_new"
                            label="New Password"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input data!',
                                },
                            ]}
                        >
                            <Input.Password />
                        </Form.Item>
                        <Form.Item
                            name="confirm_password"
                            label="Confirm Password"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input data!',
                                },
                            ]}
                        >
                            <Input.Password />
                        </Form.Item>
                        <Row justify="end">
                            <Form.Item >
                                <Button icon={<FaSave />} type="primary" htmlType="submit" disabled={isLoading}>
                                    Save
                                </Button>
                            </Form.Item>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </div>
    )
}

export default ChangePasswordForm